import { themeRegistry } from './theme-registry';

themeRegistry.registerThemeUsingCompilers('default');
